module.exports = __webpack_public_path__ + "static/media/IllustratorIcon.744ddcd2.svg";